import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M12.667 0H3.333A3.337 3.337 0 0 0 0 3.333v9.334A3.337 3.337 0 0 0 3.333 16h7.764c.858 0 1.665-.334 2.272-.94l1.69-1.691A3.24 3.24 0 0 0 16 11.097V3.333A3.337 3.337 0 0 0 12.667 0M1.333 12.667V3.333c0-1.102.898-2 2-2h9.334c1.102 0 2 .898 2 2V10H12c-1.103 0-2 .897-2 2v2.667H3.333c-1.102 0-2-.898-2-2m11.093 1.45c-.299.298-.68.483-1.093.534V12c0-.368.3-.667.667-.667h2.65c-.052.41-.24.799-.534 1.093zM3.333 4.333a1 1 0 1 1 2.001.001 1 1 0 0 1-2 0m2 3.667a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 3.667a1 1 0 1 1-2-.001 1 1 0 0 1 2 0"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }